__turbopack_context__.v({
  "ratingHigh": "PdpSchools-module__38jJaG__ratingHigh",
  "ratingLow": "PdpSchools-module__38jJaG__ratingLow",
  "ratingUnavailable": "PdpSchools-module__38jJaG__ratingUnavailable",
});
